/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import axios from 'axios';

const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      console.error("Failed to load Razorpay SDK");
      resolve(false);
    };
    document.body.appendChild(script);
  });
};

const MembershipPage = () => {
  const [showForm, setShowForm] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [gstAmount, setGstAmount] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedPlanId, setSelectedPlanId] = useState('');
  const [membershipPlans, setMembershipPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    fullName: '',
    contactNumber: '',
    email: '',
    memberType: '',
    state: '',
    dateJoined: new Date().toISOString().split('T')[0],
    biography: '',
    profilePhoto: null,
    profilePhotoPreview: null,
    interests: '',
    associateCode: '',
    ethicsDeclaration: false,
    businessPhilosophy: '',
    regulatoryHistory: '',
    regulatoryExplanation: '',

    // ✅ Address fields
    city: '',
    address: '',
    pinCode: '',
    gstNumber: '',
    // Reference member verification
    referenceMemberId: '',
    referenceMemberVerified: false,
    referenceMemberDetails: null,

    // ✅ Discount fields
    discountReferralCode: '',
    discountVerified: false,
    discountDetails: null,
    discountPercentage: 0,
    discountAmount: 0,
    discountedAmount: 0
  });

  const [formErrors, setFormErrors] = useState({});
  const [processingPayment, setProcessingPayment] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState(null);
  const [verifyingReferenceMember, setVerifyingReferenceMember] = useState(false);
  const [verifyingDiscount, setVerifyingDiscount] = useState(false);

  // Interests state
  const [interests, setInterests] = useState([]);
  const [filteredInterests, setFilteredInterests] = useState([]);
  const [flattenedKeywords, setFlattenedKeywords] = useState([]);
  const [selectedInterest, setSelectedInterest] = useState('');
  const [loadingInterests, setLoadingInterests] = useState(false);
  const [selectedMemberTypeCode, setSelectedMemberTypeCode] = useState('');

  // API URLs
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_PAID_MEMBERS = `${API_BASE_URL}/paid-members`;
  const API_OUR_MEMBERS = `${API_BASE_URL}/UIourMembers`;
  const API_URL = `${API_BASE_URL}/UImemberships`;
  const PAYMENT_API_URL = `${API_BASE_URL}/paid-members`;
  const MEDIA_API_URL = `${API_BASE_URL}/UImedia`;
  const INTERESTS_API_URL = `${API_BASE_URL}/ui-interest-keywords`;
  const API_COUPONS = `${API_BASE_URL}/UIcoupons`;

  const razorpayKey = process.env.REACT_APP_RAZORPAY_KEY_ID;

  // ✅ State for coupon options
  const [couponOptions, setCouponOptions] = useState([]);
  const [loadingCoupons, setLoadingCoupons] = useState(false);

  useEffect(() => {
    if (!razorpayKey || razorpayKey === 'rzp_test_your_key_here' || razorpayKey.includes('RAZORPAY_KEY_ID')) {
      console.error('Razorpay key not properly configured:', razorpayKey);
      setError('Payment system configuration error. Please contact support.');
    }
  }, [razorpayKey]);

  // ✅ Fetch all coupons for discount verification
  const fetchAllCoupons = async () => {
    try {
      setLoadingCoupons(true);
      const response = await axios.get(API_COUPONS);

      let couponsData = Array.isArray(response.data) ? response.data : (response.data.results || []);

      // Filter active, not expired coupons
      const activeCoupons = couponsData.filter(coupon => {
        const now = new Date();
        const expiryDate = new Date(coupon.expiryDate);
        return coupon.isActive && !coupon.isDeleted && expiryDate > now;
      });

      setCouponOptions(activeCoupons);
    } catch (error) {
      console.error("Error fetching coupons:", error);
      setCouponOptions([]);
    } finally {
      setLoadingCoupons(false);
    }
  };

  // ✅ Verify discount referral code
  const verifyDiscountReferralCode = async () => {
    if (!formData.discountReferralCode.trim()) {
      setFormErrors(prev => ({
        ...prev,
        discountReferralCode: 'Please enter Discount Referral Code'
      }));
      return;
    }

    setVerifyingDiscount(true);
    setFormErrors(prev => ({ ...prev, discountReferralCode: '' }));

    try {
      const searchCode = formData.discountReferralCode.trim().toUpperCase();

      // First try local check from fetched coupons
      if (couponOptions.length > 0) {
        const foundCoupon = couponOptions.find(coupon => {
          const couponCode = coupon.couponCode ? coupon.couponCode.toUpperCase() : '';
          return couponCode === searchCode;
        });

        if (foundCoupon) {
          // Check if coupon is expired
          const expiryDate = new Date(foundCoupon.expiryDate);
          const now = new Date();

          if (expiryDate < now) {
            setFormErrors(prev => ({
              ...prev,
              discountReferralCode: 'This coupon has expired'
            }));
            setVerifyingDiscount(false);
            return;
          }

          // ✅ CRITICAL FIX: CORRECT CALCULATION
          const discountPercentage = foundCoupon.discountPercentage || 0;
          const discountAmount = Math.round((selectedAmount * discountPercentage) / 100);
          const amountAfterDiscount = selectedAmount - discountAmount;
          const gst = (amountAfterDiscount * 18) / 100;
          const total = amountAfterDiscount + gst;


          setFormData(prev => ({
            ...prev,
            discountVerified: true,
            discountDetails: foundCoupon,
            discountPercentage: discountPercentage,
            discountAmount: discountAmount,
            discountedAmount: amountAfterDiscount // ✅ यहाँ correct value
          }));

          // Update amounts with discount
          setGstAmount(Math.round(gst));
          setTotalAmount(Math.round(total));

          setVerifyingDiscount(false);
          return;
        }
      }

      // ... rest of the function remains same
    } catch (error) {
      console.error("Error verifying discount code:", error);
      setFormErrors(prev => ({
        ...prev,
        discountReferralCode: 'Error verifying discount code. Please try again.'
      }));
    } finally {
      setVerifyingDiscount(false);
    }
  };

  // ✅ Clear discount
  const handleClearDiscount = () => {
    // Recalculate amount without discount
    const gst = (selectedAmount * 18) / 100;
    const total = selectedAmount + gst;

    setFormData(prev => ({
      ...prev,
      discountReferralCode: "",
      discountVerified: false,
      discountDetails: null,
      discountPercentage: 0,
      discountAmount: 0,
      discountedAmount: selectedAmount // ✅ Reset to selectedAmount
    }));

    setGstAmount(Math.round(gst));
    setTotalAmount(Math.round(total));
    setFormErrors(prev => ({ ...prev, discountReferralCode: "" }));
  };
  // ✅ Handle discount code blur
  const handleDiscountCodeBlur = () => {
    if (formData.discountReferralCode.trim() && !formData.discountVerified) {
      const searchCode = formData.discountReferralCode.trim().toUpperCase();

      const foundCoupon = couponOptions.find(coupon => {
        const couponCode = coupon.couponCode ? coupon.couponCode.toUpperCase() : '';
        return couponCode === searchCode;
      });

      if (foundCoupon) {
        // Check if coupon is expired
        const expiryDate = new Date(foundCoupon.expiryDate);
        const now = new Date();

        if (expiryDate < now) {
          setFormErrors(prev => ({
            ...prev,
            discountReferralCode: 'This coupon has expired'
          }));
          return;
        }

        // ✅ CRITICAL FIX: Same correct calculation
        const discountPercentage = foundCoupon.discountPercentage || 0;
        const discountAmount = Math.round((selectedAmount * discountPercentage) / 100);
        const amountAfterDiscount = selectedAmount - discountAmount;
        const gst = (amountAfterDiscount * 18) / 100;
        const total = amountAfterDiscount + gst;

        setFormData(prev => ({
          ...prev,
          discountVerified: true,
          discountDetails: foundCoupon,
          discountPercentage: discountPercentage,
          discountAmount: discountAmount,
          discountedAmount: amountAfterDiscount // ✅ यहाँ correct value
        }));

        // Update amounts with discount
        setGstAmount(Math.round(gst));
        setTotalAmount(Math.round(total));

        setFormErrors(prev => ({ ...prev, discountReferralCode: "" }));
      }
    }
  };

  // Upload media file
  const uploadMedia = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post(`${MEDIA_API_URL}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
      });
      return res.data.id; // Return media ID
    } catch (error) {
      console.error("Error uploading media:", error);
      throw new Error('Failed to upload profile photo');
    }
  };

  // Delete media
  const deleteMedia = async (mediaId) => {
    if (!mediaId) return;
    try {
      await axios.delete(`${MEDIA_API_URL}/${mediaId}`);
    } catch (error) {
      console.error("Error deleting media:", error);
    }
  };

  // ✅ FETCH ALL MEMBERS FOR REFERENCE VERIFICATION
  const [allMembers, setAllMembers] = useState([]);
  const [membersLoaded, setMembersLoaded] = useState(false);
  const [loadingMembers, setLoadingMembers] = useState(false);

  const fetchAllMembers = async () => {
    try {
      setLoadingMembers(true);

      // Fetch paid members
      const paidMembersResponse = await axios.get(API_PAID_MEMBERS);
      const paidMembersData = paidMembersResponse.data;
      const paidMembers = paidMembersData.success && Array.isArray(paidMembersData.items)
        ? paidMembersData.items
        : [];

      // Fetch our members
      const ourMembersResponse = await axios.get(API_OUR_MEMBERS);
      const ourMembersData = ourMembersResponse.data;
      const ourMembers = Array.isArray(ourMembersData)
        ? ourMembersData
        : [];

      // Process and combine all members
      const processedPaidMembers = paidMembers.map(member => ({
        id: member.id || member._id,
        memberId: member.memberId,
        name: member.formData?.fullName || member.name || 'N/A',
        email: member.formData?.email || member.email,
        phone: member.formData?.contactNumber || member.contactNumber || member.phone,
        memberType: 'paid',
        paymentStatus: member.paymentStatus,
        verificationStatus: member.verificationStatus,
        planTitle: member.planTitle,
        rawData: member
      })).filter(member => member.memberId);

      const processedOurMembers = ourMembers.map(member => ({
        id: member.id || member._id,
        memberId: member.memberId,
        name: member.name,
        email: member.email,
        phone: member.contactNumber || member.phone,
        memberType: 'regular',
        memberTypeCode: member.memberTypeCode,
        paymentStatus: member.paymentStatus,
        isActive: member.isActive,
        rawData: member
      })).filter(member => member.memberId);

      const combinedMembers = [
        ...processedPaidMembers,
        ...processedOurMembers
      ];

      setAllMembers(combinedMembers);
      setMembersLoaded(true);

    } catch (error) {
      console.error("Error fetching members data:", error);
    } finally {
      setLoadingMembers(false);
    }
  };

  // ✅ VERIFY REFERENCE MEMBER ID
  const verifyReferenceMemberId = async () => {
    if (!formData.referenceMemberId.trim()) {
      setFormErrors(prev => ({
        ...prev,
        referenceMemberId: 'Please enter Reference Member ID'
      }));
      return;
    }

    setVerifyingReferenceMember(true);
    setFormErrors(prev => ({ ...prev, referenceMemberId: '' }));

    try {
      const searchId = formData.referenceMemberId.trim().toUpperCase();

      // First try local check
      if (membersLoaded && allMembers.length > 0) {
        const foundMember = allMembers.find(member => {
          const memberIdUpper = member.memberId ? member.memberId.toUpperCase() : '';
          const idUpper = member.id ? member.id.toString().toUpperCase() : '';
          const emailUpper = member.email ? member.email.toUpperCase() : '';

          return memberIdUpper === searchId ||
            idUpper === searchId ||
            emailUpper === searchId;
        });

        if (foundMember) {
          setFormData(prev => ({
            ...prev,
            referenceMemberVerified: true,
            referenceMemberDetails: foundMember
          }));
          setVerifyingReferenceMember(false);
          return;
        }
      }

      // Fallback to API check
      let response;

      try {
        response = await axios.get(`${API_PAID_MEMBERS}/${searchId}`);

        if (response.data && response.data.success) {
          const memberData = response.data.items?.[0] || response.data;
          setFormData(prev => ({
            ...prev,
            referenceMemberVerified: true,
            referenceMemberDetails: {
              id: memberData.id,
              memberId: memberData.memberId,
              name: memberData.formData?.fullName || memberData.name,
              email: memberData.formData?.email || memberData.email,
              phone: memberData.formData?.contactNumber || memberData.contactNumber,
              memberType: 'paid',
              rawData: memberData
            }
          }));
          setVerifyingReferenceMember(false);
          return;
        }
      } catch (paidError) {
        // console.log("Not found in paid members");
      }

      // Try our members API
      try {
        response = await axios.get(`${API_OUR_MEMBERS}/${searchId}`);

        if (response.data) {
          setFormData(prev => ({
            ...prev,
            referenceMemberVerified: true,
            referenceMemberDetails: {
              id: response.data.id,
              memberId: response.data.memberId,
              name: response.data.name,
              email: response.data.email,
              phone: response.data.contactNumber,
              memberType: 'regular',
              rawData: response.data
            }
          }));
          setVerifyingReferenceMember(false);
          return;
        }
      } catch (ourError) {
        // console.log("Not found in our members either");
      }

      setFormErrors(prev => ({
        ...prev,
        referenceMemberId: 'Member ID not found. Please check and try again.'
      }));

    } catch (error) {
      console.error("Error verifying reference member:", error);
      setFormErrors(prev => ({
        ...prev,
        referenceMemberId: 'Member ID not found. Please check and try again.'
      }));
    } finally {
      setVerifyingReferenceMember(false);
    }
  };

  // Handle reference member ID input change
  const handleReferenceMemberIdBlur = () => {
    if (formData.referenceMemberId.trim() && !formData.referenceMemberVerified) {
      if (membersLoaded && allMembers.length > 0) {
        const searchId = formData.referenceMemberId.trim().toUpperCase();

        const foundMember = allMembers.find(member => {
          const memberIdUpper = member.memberId ? member.memberId.toUpperCase() : '';
          const idUpper = member.id ? member.id.toString().toUpperCase() : '';
          const emailUpper = member.email ? member.email.toUpperCase() : '';

          return memberIdUpper === searchId ||
            idUpper === searchId ||
            emailUpper === searchId;
        });

        if (foundMember) {
          setFormData(prev => ({
            ...prev,
            referenceMemberVerified: true,
            referenceMemberDetails: foundMember
          }));
          setFormErrors(prev => ({ ...prev, referenceMemberId: '' }));
        }
      }
    }
  };

  // Fetch ALL interests from API
  const fetchAllInterests = async () => {
    try {
      setLoadingInterests(true);
      const response = await axios.get(INTERESTS_API_URL);
      if (response.data && Array.isArray(response.data)) {
        setInterests(response.data);
      }
    } catch (err) {
      console.error('Error fetching interests:', err);
    } finally {
      setLoadingInterests(false);
    }
  };

  // Filter interests based on selected membership plan ID
  const filterInterestsByPlan = (planId) => {
    if (!planId || !interests.length) {
      setFilteredInterests([]);
      setFlattenedKeywords([]);
      return;
    }

    const filtered = interests.filter(interest => {
      const memberTypeId = interest.memberTypeId;
      if (typeof memberTypeId === 'object' && memberTypeId !== null) {
        return memberTypeId._id === planId;
      } else {
        return memberTypeId === planId;
      }
    });

    setFilteredInterests(filtered);

    const allKeywords = filtered.reduce((acc, interest) => {
      if (interest.keywords && Array.isArray(interest.keywords)) {
        return [...acc, ...interest.keywords];
      }
      return acc;
    }, []);

    const uniqueKeywords = [...new Set(allKeywords)];
    setFlattenedKeywords(uniqueKeywords);
  };

  // Handle interest selection
  const handleInterestSelect = (keyword) => {
    setSelectedInterest(keyword);
    setFormData(prev => ({ ...prev, interests: keyword }));
  };

  // Clear interest selection
  const handleClearInterest = () => {
    setSelectedInterest('');
    setFormData(prev => ({ ...prev, interests: '' }));
  };

  const getMembershipColor = (title) => {
    const colorMap = {
      "community": "from-blue-300 to-blue-500",
      "premium": "from-rose-200 to-rose-700",
      "gold": "from-yellow-200 to-yellow-400",
      "corporate": "from-purple-200 to-purple-500",
      "platinum": "from-gray-200 to-gray-400",
      "patron": "from-orange-200 to-orange-500"
    };

    const lowerTitle = title.toLowerCase();
    for (const [key, color] of Object.entries(colorMap)) {
      if (lowerTitle.includes(key)) {
        return color;
      }
    }

    return "from-amber-300 to-amber-500";
  };

  const formatPrice = (price) => {
    return `₹${price.toLocaleString('en-IN')}`;
  };

  // Calculate GST (18%)
  const calculateGST = (amount) => {
    const gst = (amount * 18) / 100;
    return Math.round(gst);
  };

  const fetchMembershipPlans = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_URL);

      const activePlans = response.data
        .filter(plan => plan.isActive)
        .map(plan => ({
          id: plan.id,
          title: plan.title,
          memberTypeCode: plan.memberTypeCode,
          subtitle: plan.subtitle,
          price: plan.price,
          description: plan.description,
          benefit: plan.benefit,
          color: getMembershipColor(plan.title),
          isActive: plan.isActive
        }));

      setMembershipPlans(activePlans);
    } catch (err) {
      console.error('Error fetching membership plans:', err);
      setError('Failed to load membership plans. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembershipPlans();
    fetchAllInterests();
    fetchAllMembers();
    fetchAllCoupons();
    loadRazorpayScript();
  }, []);

  const createOrder = async (orderData) => {
    try {
      const response = await axios.post(`${PAYMENT_API_URL}/create-order`, orderData);
      return response.data;
    } catch (error) {
      console.error('Error creating order:', error);
      throw new Error(error.response?.data?.message || 'Failed to create payment order');
    }
  };

  const verifyPayment = async (paymentData) => {
    try {
      // console.log('📤 Sending verifyPayment data:', {
      //   discountAmount: paymentData.discountAmount,
      //   discountPercentage: paymentData.discountPercentage,
      //   discountedAmount: paymentData.discountedAmount,
      //   hasDiscount: paymentData.discountPercentage > 0
      // });

      const response = await axios.post(`${PAYMENT_API_URL}/verify-payment`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error verifying payment:', error);
      throw new Error(error.response?.data?.message || 'Payment verification failed');
    }
  };

  const handlePayment = async (amount, name, contact, planTitle, planId, formData) => {
    setProcessingPayment(true);

    // Validate Razorpay key
    if (!razorpayKey || razorpayKey === 'rzp_test_your_key_here' || razorpayKey.includes('RAZORPAY_KEY_ID')) {
      alert("Payment configuration error. Please contact support at connect@masaforum.com");
      setProcessingPayment(false);
      return;
    }

    const res = await loadRazorpayScript();
    if (!res) {
      alert("Razorpay SDK failed to load. Check your internet connection.");
      setProcessingPayment(false);
      return;
    }

    try {
      // Upload profile photo if exists
      let profilePhotoId = null;
      if (formData.profilePhoto) {
        profilePhotoId = await uploadMedia(formData.profilePhoto);
      }

      const associateCode = formData.associateCode.trim() || "-";
      const referenceMemberId = formData.referenceMemberVerified ? formData.referenceMemberId : null;
      const discountReferralCode = formData.discountVerified ? formData.discountReferralCode : null;
      const gstNumber = formData.gstNumber.trim() || null;
      // ✅ CRITICAL FIX 1: CORRECT CALCULATION
      let baseAmount = amount;
      let discountAmt = formData.discountAmount || 0;
      let amountAfterDiscount = baseAmount - discountAmt;
      let gstAmount = calculateGST(amountAfterDiscount);
      let totalWithGST = amountAfterDiscount + gstAmount;

      // ✅ DEBUG LOG
      // console.log('💰 Final Payment Calculation:', {
      //   baseAmount,
      //   discountPercentage: formData.discountPercentage,
      //   discountAmount: discountAmt,
      //   amountAfterDiscount,
      //   gstAmount,
      //   totalWithGST
      // });

      // ✅ CRITICAL FIX 2: If 100% discount, make it ₹1 for Razorpay
      const razorpayAmount = amountAfterDiscount === 0 ? 1 : amountAfterDiscount;

      // ✅ CRITICAL FIX 3: Always set discountedAmount in formData
      const updatedFormData = {
        ...formData,
        discountedAmount: amountAfterDiscount
      };

      // Create order with all details
      const order = await createOrder({
        amount: razorpayAmount, // ✅ यहाँ corrected amount भेजें
        discountAmount: discountAmt,
        discountedAmount: amountAfterDiscount,
        discountPercentage: formData.discountPercentage || 0,
        discountReferralCode: discountReferralCode,
        gstAmount: gstAmount,
        totalAmount: totalWithGST,
        planTitle: planTitle,
        formData: {
          fullName: formData.fullName,
          contactNumber: formData.contactNumber,
          email: formData.email,
          memberType: planTitle,
          memberTypeCode: selectedMemberTypeCode,
          state: formData.state,

          // Address fields
          city: formData.city,
          address: formData.address,
          pinCode: formData.pinCode,
          gstNumber: gstNumber,
          dateJoined: formData.dateJoined,
          biography: formData.biography,
          profilePhoto: profilePhotoId,
          interests: formData.interests,
          associateCode: associateCode,
          ethicsDeclaration: formData.ethicsDeclaration,
          businessPhilosophy: formData.businessPhilosophy,
          regulatoryHistory: formData.regulatoryHistory,
          regulatoryExplanation: formData.regulatoryHistory === 'Yes' ? formData.regulatoryExplanation : '',

          // Reference member ID
          referenceMemberId: referenceMemberId,
          referenceMemberName: formData.referenceMemberDetails?.name || null,

          // ✅ Discount fields (ALWAYS SEND)
          discountReferralCode: discountReferralCode,
          discountPercentage: formData.discountPercentage || 0,
          discountAmount: discountAmt,
          discountedAmount: amountAfterDiscount
        }
      });

      // ✅ CRITICAL FIX 4: Razorpay amount
      const options = {
        key: razorpayKey,
        amount: order.amount, // ✅ यह Razorpay से आया amount है
        currency: order.currency || 'INR',
        name: "MASA Forum",
        description: amountAfterDiscount === 0
          ? `Membership Payment - ${planTitle} (100% Discount - Symbolic ₹1 Payment)`
          : `Membership Payment - ${planTitle} ${formData.discountPercentage > 0 ? `(${formData.discountPercentage}% Discount Applied)` : ''}`,
        order_id: order.id,
        handler: async function (response) {
          try {
            // console.log('💰 Payment successful, sending verification:', {
            //   razorpayAmount: order.amount,
            //   originalAmount: amount,
            //   discountAmount: discountAmt,
            //   discountPercentage: formData.discountPercentage || 0,
            //   discountedAmount: amountAfterDiscount,
            //   hasDiscount: formData.discountPercentage > 0,
            //   isFree: amountAfterDiscount === 0
            // });

            const verification = await verifyPayment({
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              formData: {
                fullName: formData.fullName,
                contactNumber: formData.contactNumber,
                email: formData.email,
                memberType: planTitle,
                memberTypeCode: selectedMemberTypeCode,
                state: formData.state,

                // Address fields
                city: formData.city,
                address: formData.address,
                pinCode: formData.pinCode,
                gstNumber: gstNumber,
                dateJoined: formData.dateJoined,
                biography: formData.biography,
                profilePhoto: profilePhotoId,
                interests: formData.interests,
                associateCode: associateCode,
                ethicsDeclaration: formData.ethicsDeclaration,
                businessPhilosophy: formData.businessPhilosophy,
                regulatoryHistory: formData.regulatoryHistory,
                regulatoryExplanation: formData.regulatoryHistory === 'Yes' ? formData.regulatoryExplanation : '',

                referenceMemberId: referenceMemberId,
                referenceMemberName: formData.referenceMemberDetails?.name || null,

                // ✅ Discount fields
                discountReferralCode: discountReferralCode,
                discountPercentage: formData.discountPercentage || 0,
                discountAmount: discountAmt,
                discountedAmount: amountAfterDiscount
              },
              planTitle: planTitle,
              amount: amount, // Original amount
              // ✅ THESE 3 FIELDS ARE CRITICAL
              discountAmount: discountAmt,
              discountedAmount: amountAfterDiscount,
              discountPercentage: formData.discountPercentage || 0,
              gstAmount: gstAmount,
              totalAmount: totalWithGST,
              razorpayAmount: order.amount // ✅ Razorpay में जो amount था
            });

            // Store invoice details for success screen
            setInvoiceDetails({
              invoiceNumber: verification.member.invoiceNumber,
              memberId: verification.member.memberId,
              fullName: verification.member.fullName,
              email: verification.member.email,
              planTitle: verification.member.planTitle,

              baseAmount: verification.member.amount,
              discountAmount: discountAmt,
              discountPercentage: formData.discountPercentage || 0,
              discountedAmount: amountAfterDiscount,
              gstAmount: verification.member.gstAmount,
              totalAmount: verification.member.totalAmount,

              paymentId: response.razorpay_payment_id,
              associateCode: associateCode,

              // Address fields
              city: formData.city,
              address: formData.address,
              pinCode: formData.pinCode,
              gstNumber: gstNumber,
              // Reference member info
              referenceMemberId: referenceMemberId,
              referenceMemberName: formData.referenceMemberDetails?.name || null,

              // Discount info
              discountReferralCode: discountReferralCode,

              // ✅ ADD THIS: Show if it was symbolic payment
              isSymbolicPayment: amountAfterDiscount === 0
            });

            setPaymentSuccess(true);

          } catch (err) {
            console.error("Verification failed:", err);
            alert("Payment verification failed. Please contact support with your order details.");
          } finally {
            setProcessingPayment(false);
          }
        },
        prefill: {
          name: name,
          contact: contact,
          email: formData.email
        },
        theme: {
          color: "#1e40af"
        },
        modal: {
          ondismiss: function () {
            setProcessingPayment(false);
          }
        },
        notes: {
          plan: planTitle,
          memberName: name,
          address: `${formData.address}, ${formData.city}, ${formData.state} - ${formData.pinCode}`,
          gstNumber: gstNumber || 'Not Provided',
          associateCode: associateCode,
          paymentBreakdown: `Base:${amount}|Disc:${discountAmt}|AfterDisc:${amountAfterDiscount}|GST:${gstAmount}|Total:${totalWithGST}`,
          discountDetails: formData.discountPercentage > 0
            ? `Code:${discountReferralCode}|Percent:${formData.discountPercentage}`
            : 'No discount',
          referenceMember: referenceMemberId || 'No reference',
          symbolicPayment: amountAfterDiscount === 0 ? 'Yes' : 'No'
        }
      };

      const rzp = new window.Razorpay(options);

      rzp.on('payment.failed', function (response) {
        console.error('Payment failed:', response.error);
        alert(`Payment failed: ${response.error.description}. Please try again or contact support.`);
        setProcessingPayment(false);
      });

      rzp.open();

    } catch (error) {
      console.error("Payment Error:", error);
      alert("Error initiating payment: " + error.message);
      setProcessingPayment(false);
    }
  };
  const handleJoinNow = (amount, title, id, memberTypeCode) => {
    // Check if Razorpay is configured before showing form
    if (!razorpayKey || razorpayKey === 'rzp_test_your_key_here' || razorpayKey.includes('RAZORPAY_KEY_ID')) {
      alert("Payment system is currently being configured. Please try again later or contact support at connect@masaforum.com");
      return;
    }

    // Calculate GST and total (WITHOUT DISCOUNT initially)
    const gst = calculateGST(amount);
    const total = amount + gst;

    setSelectedAmount(amount);
    setGstAmount(gst);
    setTotalAmount(total);
    setSelectedPlan(title);
    setSelectedPlanId(id);
    setSelectedMemberTypeCode(memberTypeCode);
    setShowForm(true);
    setSelectedInterest('');
    setFlattenedKeywords([]);

    // ✅ FIXED: Reset form data CORRECTLY
    setFormData({
      fullName: '',
      contactNumber: '',
      email: '',
      memberType: title,
      state: '',
      dateJoined: new Date().toISOString().split('T')[0],
      biography: '',
      profilePhoto: null,
      profilePhotoPreview: null,
      interests: '',
      associateCode: '',
      ethicsDeclaration: false,
      businessPhilosophy: '',
      regulatoryHistory: '',
      regulatoryExplanation: '',

      // Address fields
      city: '',
      address: '',
      pinCode: '',
      gstNumber: '',
      // Reference member verification
      referenceMemberId: '',
      referenceMemberVerified: false,
      referenceMemberDetails: null,

      // ✅ CRITICAL FIX: Discount fields - discountedAmount = amount initially
      discountReferralCode: '',
      discountVerified: false,
      discountDetails: null,
      discountPercentage: 0,
      discountAmount: 0,
      discountedAmount: amount // ✅ यहाँ amount set करें, 0 नहीं
    });

    setFormErrors({});

    // Filter interests based on selected plan ID
    filterInterestsByPlan(id);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Special handling for PIN code (only numbers, max 6 digits)
    if (name === "pinCode") {
      const numericValue = value.replace(/\D/g, '').slice(0, 6);
      setFormData(prev => ({
        ...prev,
        [name]: numericValue
      }));
    }
    // ✅ NEW: Special handling for GST number (uppercase and remove spaces)
    else if (name === "gstNumber") {
      const cleanedValue = value.replace(/\s/g, '').toUpperCase();
      setFormData(prev => ({
        ...prev,
        [name]: cleanedValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value,
        // If referenceMemberId changes, reset verification
        ...(name === "referenceMemberId" && {
          referenceMemberVerified: false,
          referenceMemberDetails: null
        }),
        // If discountReferralCode changes, reset verification
        ...(name === "discountReferralCode" && {
          discountVerified: false,
          discountDetails: null,
          discountPercentage: 0,
          discountAmount: 0,
          discountedAmount: selectedAmount || 0
        })
      }));
    }

    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setFormErrors(prev => ({
          ...prev,
          profilePhoto: 'Please select an image file'
        }));
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        setFormErrors(prev => ({
          ...prev,
          profilePhoto: 'Image size should be less than 5MB'
        }));
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData(prev => ({
          ...prev,
          profilePhoto: file,
          profilePhotoPreview: e.target.result
        }));
      };
      reader.readAsDataURL(file);

      if (formErrors.profilePhoto) {
        setFormErrors(prev => ({
          ...prev,
          profilePhoto: ''
        }));
      }
    }
  };

  const removeProfilePhoto = async () => {
    if (formData.profilePhoto && formData.profilePhoto.id) {
      await deleteMedia(formData.profilePhoto.id);
    }
    setFormData(prev => ({
      ...prev,
      profilePhoto: null,
      profilePhotoPreview: null
    }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.fullName.trim()) {
      errors.fullName = 'Full name is required';
    }

    if (!formData.contactNumber.trim()) {
      errors.contactNumber = 'Contact number is required';
    } else if (!/^\d{10}$/.test(formData.contactNumber.replace(/\D/g, ''))) {
      errors.contactNumber = 'Please enter a valid 10-digit phone number';
    }

    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!formData.state.trim()) {
      errors.state = 'State is required';
    }

    // Address validation
    if (!formData.city.trim()) {
      errors.city = 'City is required';
    }

    if (!formData.address.trim()) {
      errors.address = 'Address is required';
    } else if (formData.address.trim().length < 5) {
      errors.address = 'Address should be at least 5 characters long';
    }

    if (!formData.pinCode.trim()) {
      errors.pinCode = 'PIN Code is required';
    } else if (!/^\d{6}$/.test(formData.pinCode)) {
      errors.pinCode = 'Please enter a valid 6-digit PIN Code';
    }

    if (formData.gstNumber.trim()) {
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (!gstRegex.test(formData.gstNumber.toUpperCase())) {
        errors.gstNumber = 'Please enter a valid GST number (15 characters)';
      }
    }

    if (!formData.biography.trim()) {
      errors.biography = 'Biography is required';
    } else if (formData.biography.length < 2) {
      errors.biography = 'Biography should be at least 2 characters long';
    }

    if (formData.associateCode && formData.associateCode.trim().length < 1 && formData.associateCode.trim() !== "-") {
      errors.associateCode = 'Associate code must be at least 1 character if provided';
    }

    if (!formData.ethicsDeclaration) {
      errors.ethicsDeclaration = 'Ethics declaration is required';
    }

    if (!formData.businessPhilosophy) {
      errors.businessPhilosophy = 'Business philosophy selection is required';
    }

    if (!formData.regulatoryHistory) {
      errors.regulatoryHistory = 'Regulatory history selection is required';
    }

    if (formData.regulatoryHistory === 'Yes' && !formData.regulatoryExplanation.trim()) {
      errors.regulatoryExplanation = 'Please provide explanation';
    }

    // Validate reference member ID if entered
    if (formData.referenceMemberId && !formData.referenceMemberVerified) {
      errors.referenceMemberId = 'Please verify the Reference Member ID';
    }

    // Validate discount referral code if entered
    if (formData.discountReferralCode && !formData.discountVerified) {
      errors.discountReferralCode = 'Please verify the Discount Referral Code';
    }
    if (!formData.profilePhoto) {
      errors.profilePhoto = 'Profile photo is required';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleProceedToPayment = () => {
    if (!validateForm()) {
      alert('Please fix the errors in the form before proceeding.');
      return;
    }
    if (!formData.profilePhoto) {
      alert('Please upload your profile photo before proceeding.');
      return;
    }


    handlePayment(selectedAmount, formData.fullName, formData.contactNumber, selectedPlan, selectedPlanId, formData);
  };

  const handleCompleteRegistration = () => {
    // Reset everything
    setPaymentSuccess(false);
    setShowForm(false);
    setInvoiceDetails(null);
    setSelectedInterest('');
    setFilteredInterests([]);
    setFlattenedKeywords([]);
    setFormData({
      fullName: '',
      contactNumber: '',
      email: '',
      memberType: '',
      state: '',
      dateJoined: new Date().toISOString().split('T')[0],
      biography: '',
      profilePhoto: null,
      profilePhotoPreview: null,
      interests: '',
      associateCode: '',
      ethicsDeclaration: false,
      businessPhilosophy: '',
      regulatoryHistory: '',
      regulatoryExplanation: '',

      // Address fields
      city: '',
      address: '',
      pinCode: '',
      gstNumber: '',
      referenceMemberId: '',
      referenceMemberVerified: false,
      referenceMemberDetails: null,

      // Discount fields
      discountReferralCode: '',
      discountVerified: false,
      discountDetails: null,
      discountPercentage: 0,
      discountAmount: 0,
      discountedAmount: 0
    });
  };

  const SuccessScreen = () => (
    <div className="fixed inset-0 bg-black/70 flex  justify-center p-2 sm:p-4 md:p-6 z-50 overflow-y-auto">
      <div className="bg-gray-900 rounded-xl sm:rounded-2xl shadow-2xl max-w-full w-full mx-2 sm:mx-auto md:max-w-2xl lg:max-w-3xl border border-gray-700/50 backdrop-blur-sm  sm:my-4 md:my-8">
        <div className="bg-gradient-to-r from-green-600 to-emerald-600 p-4 sm:p-6 md:p-8 rounded-t-xl sm:rounded-t-2xl">
          <div className="flex items-center justify-center mb-3 sm:mb-4 md:mb-6">
            <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center">
              <svg className="w-5 h-5 sm:w-6 sm:h-6 md:w-10 md:h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          </div>
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-white text-center">Payment Successful! 🎉</h2>
          <p className="text-white text-opacity-90 text-xs sm:text-sm md:text-base text-center mt-1 sm:mt-2">
            Welcome to MASA Forum!
          </p>
        </div>

        <div className="p-3 sm:p-4 md:p-6 lg:p-8">
          <div className="text-center mb-4 sm:mb-6 md:mb-8">
            <p className="text-gray-300 text-sm sm:text-base md:text-lg lg:text-xl">
              Thank you for joining <strong>MASA Forum</strong>!
            </p>
            <p className="text-gray-400 text-xs sm:text-sm md:text-base mt-1 sm:mt-2 md:mt-3">
              Your membership has been activated successfully.
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-3 sm:p-4 md:p-6 border border-gray-600">
            <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl font-semibold text-white mb-3 sm:mb-4 md:mb-6 text-center">Membership Details</h3>

            <div className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 gap-2 sm:gap-3 md:gap-4 mb-3 sm:mb-4 md:mb-6">
              <div>
                <p className="text-gray-400 text-xs sm:text-sm md:text-base">Member ID</p>
                <p className="text-white font-semibold text-sm sm:text-base md:text-lg truncate">{invoiceDetails?.memberId}</p>
              </div>
              <div>
                <p className="text-gray-400 text-xs sm:text-sm md:text-base">Invoice Number</p>
                <p className="text-white font-semibold text-xs sm:text-sm md:text-base truncate">{invoiceDetails?.invoiceNumber}</p>
              </div>
              <div>
                <p className="text-gray-400 text-xs sm:text-sm md:text-base">Plan</p>
                <p className="text-white font-semibold text-xs sm:text-sm md:text-base truncate">{invoiceDetails?.planTitle}</p>
              </div>
              <div>
                <p className="text-gray-400 text-xs sm:text-sm md:text-base">Payment ID</p>
                <p className="text-white font-semibold text-xs sm:text-sm md:text-base truncate">{invoiceDetails?.paymentId}</p>
              </div>

              {/* City and State */}
              <div>
                <p className="text-gray-400 text-xs sm:text-sm md:text-base">City</p>
                <p className="text-white font-semibold text-xs sm:text-sm md:text-base truncate">{invoiceDetails?.city}</p>
              </div>


              {/* ✅ ADD: Symbolic Payment Indicator */}
              {invoiceDetails?.isSymbolicPayment && (
                <div className="xs:col-span-2 sm:col-span-2 md:col-span-2">
                  <div className="bg-yellow-900/30 border border-yellow-700/50 rounded-lg p-2 sm:p-3 md:p-4">
                    <p className="text-yellow-300 text-xs sm:text-sm md:text-base font-semibold flex items-center gap-1 sm:gap-2">
                      <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                      <span className="truncate">Symbolic Payment: ₹1 (100% Discount Applied)</span>
                    </p>
                  </div>
                </div>
              )}

              {/* Discount info if applied */}
              {invoiceDetails?.discountPercentage > 0 && (
                <>
                  <div>
                    <p className="text-gray-400 text-xs sm:text-sm md:text-base">Discount Code</p>
                    <p className="text-white font-semibold text-xs sm:text-sm md:text-base truncate">{invoiceDetails?.discountReferralCode}</p>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs sm:text-sm md:text-base">Discount</p>
                    <p className="text-white font-semibold text-green-400 text-xs sm:text-sm md:text-base">{invoiceDetails?.discountPercentage}%</p>
                  </div>
                </>
              )}

              {/* Reference member info */}
              {invoiceDetails?.referenceMemberId && (
                <>
                  <div>
                    <p className="text-gray-400 text-xs sm:text-sm md:text-base">Reference Member ID</p>
                    <p className="text-white font-semibold text-xs sm:text-sm md:text-base truncate">{invoiceDetails?.referenceMemberId}</p>
                  </div>
                  <div>
                    <p className="text-gray-400 text-xs sm:text-sm md:text-base">Reference Member</p>
                    <p className="text-white font-semibold text-xs sm:text-sm md:text-base truncate">{invoiceDetails?.referenceMemberName}</p>
                  </div>
                </>
              )}
            </div>

            {/* Address section */}
            <div className="mt-3 sm:mt-4 md:mt-6 p-2 sm:p-3 md:p-4 bg-gray-700/30 rounded-lg">
              <h4 className="text-gray-300 font-semibold text-xs sm:text-sm md:text-base mb-1 sm:mb-2 flex items-center gap-1 sm:gap-2">
                <svg className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>Address</span>
              </h4>
              <p className="text-gray-300 text-xs sm:text-sm md:text-base break-words leading-relaxed">
                {invoiceDetails?.address}, {invoiceDetails?.city}, {invoiceDetails?.state} - {invoiceDetails?.pinCode}
              </p>
            </div>

            {/* Payment Breakdown */}
            <div className="mt-4 sm:mt-6 md:mt-8 pt-3 sm:pt-4 md:pt-6 border-t border-gray-700">
              <h4 className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-white mb-2 sm:mb-3 md:mb-4">Payment Breakdown</h4>
              <div className="space-y-1 sm:space-y-2 md:space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-400 text-xs sm:text-sm md:text-base">Base Amount:</span>
                  <span className="text-white text-xs sm:text-sm md:text-base">₹{invoiceDetails?.baseAmount?.toLocaleString('en-IN')}</span>
                </div>

                {/* Discount if applied */}
                {invoiceDetails?.discountPercentage > 0 && (
                  <>
                    <div className="flex justify-between">
                      <span className="text-gray-400 text-xs sm:text-sm md:text-base">Discount ({invoiceDetails?.discountPercentage}%):</span>
                      <span className="text-green-400 text-xs sm:text-sm md:text-base">- ₹{invoiceDetails?.discountAmount?.toLocaleString('en-IN')}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-400 text-xs sm:text-sm md:text-base">Amount After Discount:</span>
                      <span className="text-white text-xs sm:text-sm md:text-base">₹{invoiceDetails?.discountedAmount?.toLocaleString('en-IN')}</span>
                    </div>
                  </>
                )}

                <div className="flex justify-between">
                  <span className="text-gray-400 text-xs sm:text-sm md:text-base">GST (18%):</span>
                  <span className="text-white text-xs sm:text-sm md:text-base">+ ₹{invoiceDetails?.gstAmount?.toLocaleString('en-IN')}</span>
                </div>

                {/* ✅ ADD: Symbolic Payment Line */}
                {invoiceDetails?.isSymbolicPayment && (
                  <div className="flex justify-between">
                    <span className="text-gray-400 text-xs sm:text-sm md:text-base">Symbolic Razorpay Payment:</span>
                    <span className="text-yellow-400 text-xs sm:text-sm md:text-base">₹1</span>
                  </div>
                )}

                <div className="flex justify-between pt-2 sm:pt-3 md:pt-4 border-t border-gray-700">
                  <span className="text-gray-300 font-semibold text-sm sm:text-base md:text-lg">Total Amount Paid:</span>
                  <span className="text-green-400 font-bold text-base sm:text-lg md:text-xl lg:text-2xl">
                    ₹{invoiceDetails?.isSymbolicPayment ? '1' : invoiceDetails?.totalAmount?.toLocaleString('en-IN')}
                  </span>
                </div>
              </div>
            </div>

            <div className="mt-3 sm:mt-4 md:mt-6">
              <p className="text-gray-400 text-xs sm:text-sm md:text-base">Associate Code</p>
              <p className="text-white font-semibold text-sm sm:text-base md:text-lg">
                {invoiceDetails?.associateCode === "-" ? "Not Applicable" : invoiceDetails?.associateCode}
              </p>
            </div>
          </div>

          <div className="mt-4 sm:mt-6 md:mt-1 p-2 sm:p-3 md:p-4 bg-gray-900 border border-gray-700 rounded-lg">
            <h4 className="text-blue-300 font-semibold text-sm sm:text-base md:text-lg mb-1 sm:mb-2 md:mb-3">📧 Check Your Email</h4>
            <p className="text-gray-300 text-xs sm:text-sm md:text-base">
              We've sent the following emails to <strong>{invoiceDetails?.email}</strong>:
            </p>
            <ul className="text-gray-400 text-xs sm:text-sm md:text-base mt-1 sm:mt-2 md:mt-3 space-y-1 sm:space-y-1.5 md:space-y-2">
              <li className="flex items-start gap-1 sm:gap-2">
                <span className="text-green-400 mt-0.5">✅</span>
                <span>Payment confirmation with GST invoice</span>
              </li>
              <li className="flex items-start gap-1 sm:gap-2">
                <span className="text-green-400 mt-0.5">✅</span>
                <span>Welcome email with member benefits</span>
              </li>
              <li className="flex items-start gap-1 sm:gap-2">
                <span className="text-green-400 mt-0.5">✅</span>
                <span>Invoice with payment breakdown</span>
              </li>
              <li className="flex items-start gap-1 sm:gap-2">
                <span className="text-green-400 mt-0.5">✅</span>
                <span>Your Member ID: <strong>{invoiceDetails?.memberId}</strong></span>
              </li>
              <li className="flex items-start gap-1 sm:gap-2">
                <span className="text-green-400 mt-0.5">✅</span>
                <span>Your Address: <strong className="break-words">{invoiceDetails?.address}, {invoiceDetails?.city}, {invoiceDetails?.state} - {invoiceDetails?.pinCode}</strong></span>
              </li>
              {invoiceDetails?.associateCode && invoiceDetails?.associateCode !== "-" && (
                <li className="flex items-start gap-1 sm:gap-2">
                  <span className="text-green-400 mt-0.5">✅</span>
                  <span>Associate Code: <strong>{invoiceDetails?.associateCode}</strong></span>
                </li>
              )}
              {invoiceDetails?.gstNumber && (
                <li className="flex items-start gap-1 sm:gap-2">
                  <span className="text-green-400 mt-0.5">✅</span>
                  <span>GST Number: <strong className="font-mono">{invoiceDetails?.gstNumber}</strong></span>
                </li>
              )}
              {invoiceDetails?.discountPercentage > 0 && (
                <>
                  <li className="flex items-start gap-1 sm:gap-2">
                    <span className="text-green-400 mt-0.5">✅</span>
                    <span>Discount Applied: <strong>{invoiceDetails?.discountPercentage}% off</strong></span>
                  </li>
                  <li className="flex items-start gap-1 sm:gap-2">
                    <span className="text-green-400 mt-0.5">✅</span>
                    <span>Discount Amount: <strong>₹{invoiceDetails?.discountAmount?.toLocaleString('en-IN')}</strong></span>
                  </li>
                  <li className="flex items-start gap-1 sm:gap-2">
                    <span className="text-green-400 mt-0.5">✅</span>
                    <span>Final Amount: <strong>₹{invoiceDetails?.discountedAmount?.toLocaleString('en-IN')}</strong></span>
                  </li>
                </>
              )}
              {invoiceDetails?.isSymbolicPayment && (
                <li className="flex items-start gap-1 sm:gap-2">
                  <span className="text-green-400 mt-0.5">✅</span>
                  <span>Symbolic Payment: <strong>₹1 (Razorpay minimum requirement)</strong></span>
                </li>
              )}
              {invoiceDetails?.referenceMemberId && (
                <li className="flex items-start gap-1 sm:gap-2">
                  <span className="text-green-400 mt-0.5">✅</span>
                  <span>Reference Member: <strong>{invoiceDetails?.referenceMemberName} ({invoiceDetails?.referenceMemberId})</strong></span>
                </li>
              )}
            </ul>
          </div>

          <div className="flex justify-center mt-4 sm:mt-6 md:mt-8">
            <button
              onClick={handleCompleteRegistration}
              className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-semibold text-sm sm:text-base md:text-lg py-2 sm:py-3 px-4 sm:px-6 md:py-4 md:px-8 rounded-lg transition-all hover:scale-105 active:scale-95 w-full sm:w-auto min-h-[44px] sm:min-h-[48px]"
            >
              Complete Registration
            </button>
          </div>

          <div className="text-center mt-4 sm:mt-6 md:mt-8">
            <p className="text-gray-400 text-xs sm:text-sm md:text-base">
              Need help? Contact us at{' '}
              <a href="mailto:connect@masaforum.com" className="text-blue-400 hover:text-blue-300 underline break-all sm:break-words">
                connect@masaforum.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
  // Show configuration error if Razorpay key is not set
  if (!razorpayKey || razorpayKey === 'rzp_test_your_key_here' || razorpayKey.includes('RAZORPAY_KEY_ID')) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center max-w-2xl mx-4">
          <div className="text-yellow-400 text-6xl mb-4">⚙️</div>
          <h2 className="text-2xl font-bold text-white mb-4">Payment System Configuration</h2>
          <p className="text-gray-300 mb-4">
            The payment system is currently being configured. Please check back later or contact support for assistance.
          </p>
          <div className="bg-gray-800 p-4 rounded-lg mb-4">
            <p className="text-sm text-gray-400">
              Contact: <a href="mailto:connect@masaforum.com" className="text-yellow-400 underline">connect@masaforum.com</a>
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-yellow-400 mx-auto mb-4"></div>
          <p className="text-xl text-gray-300">Loading membership plans...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-400 text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-white mb-2">Error Loading Plans</h2>
          <p className="text-gray-300 mb-4">{error}</p>
          <button
            onClick={fetchMembershipPlans}
            className="bg-gradient-to-r from-yellow-400 to-red-500 text-white px-6 py-3 rounded-lg font-semibold hover:from-yellow-500 hover:to-red-600 transition-all duration-300"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 via-red-500 to-purple-600 animate-pulse">
            MASA Membership Plans
          </h1>
          <p className="mt-4 text-xl text-gray-300">
            Join the MSME And Startups Acceleration (MASA) community today
          </p>
        </div>

        {membershipPlans.length === 0 ? (
          <div className="text-center py-12">
            <div className="text-yellow-400 text-6xl mb-4">💎</div>
            <h3 className="text-2xl font-bold text-white mb-2">No Active Membership Plans</h3>
            <p className="text-gray-300">Please check back later for available membership plans.</p>
          </div>
        ) : (
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {membershipPlans.map((plan) => {
              const gstAmount = calculateGST(plan.price);
              const totalWithGST = plan.price + gstAmount;

              return (
                <div
                  key={plan.id}
                  className={`relative bg-gradient-to-br ${plan.color} rounded-2xl shadow-2xl overflow-hidden transform hover:scale-105 transition-all duration-300 border border-gray-700 hover:border-white group`}
                >
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-all duration-300"></div>
                  <div className="relative p-8 flex flex-col h-full">
                    <div className="flex-1">
                      <h2 className="text-2xl font-extrabold text-white mb-2 z-10">{plan.title}</h2>
                      {plan.subtitle && (
                        <p className="text-white text-opacity-90 text-sm mb-4 z-10">{plan.subtitle}</p>
                      )}

                      {/* Price Display with GST */}
                      <div className="mb-4">
                        <div className="flex items-baseline gap-2">
                          <span className="text-4xl font-bold text-white drop-shadow-lg">
                            {formatPrice(plan.price)}
                          </span>
                          <span className="text-white text-opacity-80 text-sm">(+18% GST extra)</span>
                        </div>
                      </div>

                      {plan.description && (
                        <p className="text-white text-opacity-90 text-sm mb-4 z-10 leading-relaxed">
                          {plan.description}
                        </p>
                      )}

                      {plan.benefit && plan.benefit.length > 0 && (
                        <div className="mb-6">
                          <h4 className="font-semibold text-white text-sm mb-3 z-10">Benefits:</h4>
                          <ul className="space-y-2">
                            {plan.benefit.map((benefit, benefitIndex) => (
                              <li
                                key={benefitIndex}
                                className="flex items-start gap-2 text-sm text-white text-opacity-90"
                              >
                                <div className="w-1.5 h-1.5 bg-white bg-opacity-80 rounded-full mt-2 flex-shrink-0"></div>
                                <span>{benefit}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    <button
                      className="w-full bg-white text-gray-900 font-semibold py-3 px-6 rounded-lg hover:bg-gray-100 transition duration-200 transform hover:-translate-y-1 z-10 mt-auto"
                      onClick={() => handleJoinNow(plan.price, plan.title, plan.id, plan.memberTypeCode)}
                      disabled={processingPayment}
                    >
                      {processingPayment ? 'Processing...' : 'Apply Now'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="text-center mt-12">
          <p className="text-lg text-gray-300">
            Contact us for more details:
            <a href="mailto:connect@masaforum.com" className="text-yellow-400 hover:text-yellow-300 mx-2 underline">
              connect@masaforum.com
            </a>
          </p>
        </div>
      </div>

      {/* Application Form Modal */}
      {showForm && !paymentSuccess && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50 overflow-y-auto">
          <div className="bg-gray-900 rounded-2xl shadow-2xl max-w-2xl w-full border border-gray-700/50 backdrop-blur-sm my-8">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 rounded-t-2xl">
              <h2 className="text-2xl font-bold text-white">Apply for {selectedPlan}</h2>
              <div className="text-white text-opacity-90 text-sm mt-2">
                <div className="flex flex-wrap gap-4">
                  <div>
                    <span className="font-medium">Base Fee:</span> {formatPrice(selectedAmount)}
                  </div>
                  {formData.discountPercentage > 0 && (
                    <div>
                      <span className="font-medium">Discount:</span> {formData.discountPercentage}% (₹{formData.discountAmount?.toLocaleString('en-IN')})
                    </div>
                  )}
                  <div>
                    <span className="font-medium">Total:</span> {formatPrice(totalAmount)}
                  </div>
                </div>
              </div>
            </div>

            <div className="p-6 max-h-[80vh] overflow-y-auto">
              <div className="space-y-6">
                {/* DISCOUNT REFERRAL CODE SECTION */}
                <div className="p-4 bg-gradient-to-r from-pink-900/10 to-red-900/10 rounded-xl border border-pink-700/20">
                  <label className="block text-sm font-medium text-gray-300 mb-3">
                    Discount Referral Code (Optional)
                    <span className="text-gray-400 text-sm font-normal ml-2">
                      Enter coupon code for discount
                    </span>
                  </label>
                  <div className="flex gap-3">
                    <div className="flex-1">
                      <div className="relative">
                        <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                        </svg>
                        <input
                          type="text"
                          name="discountReferralCode"
                          value={formData.discountReferralCode}
                          onChange={handleInputChange}
                          onBlur={handleDiscountCodeBlur}
                          className={`w-full pl-10 pr-4 py-3 bg-gray-800/50 border rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent placeholder-gray-400 ${formErrors.discountReferralCode ? 'border-red-500' : 'border-gray-600'
                            }`}
                          placeholder="Enter discount coupon code"
                          disabled={formData.discountVerified}
                        />
                      </div>
                      {formErrors.discountReferralCode && (
                        <p className="text-red-400 text-sm mt-1">{formErrors.discountReferralCode}</p>
                      )}
                    </div>
                    <button
                      type="button"
                      onClick={verifyDiscountReferralCode}
                      disabled={verifyingDiscount || !formData.discountReferralCode.trim() || formData.discountVerified}
                      className="px-6 py-3 bg-gradient-to-r from-pink-600 to-red-600 hover:from-pink-700 hover:to-red-700 disabled:from-gray-700 disabled:to-gray-800 disabled:cursor-not-allowed rounded-lg font-medium flex items-center gap-2 min-w-[120px] justify-center"
                    >
                      {verifyingDiscount ? (
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                      ) : (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                      )}
                      {verifyingDiscount ? "Verifying..." : "Verify Code"}
                    </button>
                  </div>

                  {/* Display verified discount */}
                  {formData.discountVerified && formData.discountDetails && (
                    <div className="mt-3 p-3 bg-gradient-to-r from-green-900/20 to-emerald-900/20 rounded-lg border border-green-700/50">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2 text-green-400">
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <span className="font-bold">Discount Applied!</span>
                        </div>
                        <button
                          type="button"
                          onClick={handleClearDiscount}
                          className="text-xs text-red-400 hover:text-red-300 flex items-center gap-1"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                          Remove
                        </button>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2 text-sm">
                        <div>
                          <span className="text-gray-400">Coupon Code:</span>
                          <span className="text-white ml-2 font-mono">{formData.discountDetails.couponCode}</span>
                        </div>
                        <div>
                          <span className="text-gray-400">Discount:</span>
                          <span className="text-white ml-2 text-green-400">{formData.discountPercentage}% OFF</span>
                        </div>
                        <div>
                          <span className="text-gray-400">Coupon Name:</span>
                          <span className="text-white ml-2">{formData.discountDetails.couponName}</span>
                        </div>
                        <div>
                          <span className="text-gray-400">Expiry:</span>
                          <span className="text-white ml-2">{new Date(formData.discountDetails.expiryDate).toLocaleDateString()}</span>
                        </div>
                      </div>
                      <div className="mt-2 pt-2 border-t border-green-700/30">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-300">Discount Amount:</span>
                          <span className="text-lg font-bold text-green-400">
                            -₹{formData.discountAmount?.toLocaleString('en-IN')}
                          </span>
                        </div>
                        <div className="flex justify-between items-center mt-1">
                          <span className="text-sm text-gray-300">Amount After Discount:</span>
                          <span className="text-lg font-bold text-white">
                            ₹{formData.discountedAmount?.toLocaleString('en-IN')}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  <p className="text-gray-500 text-xs mt-2">
                    Leave empty if you don't have a discount code
                  </p>
                </div>

                {/* REFERENCE MEMBER ID VERIFICATION SECTION */}
                <div className="p-4 bg-gradient-to-r from-purple-900/10 to-blue-900/10 rounded-xl border border-purple-700/20">
                  <label className="block text-sm font-medium text-gray-300 mb-3">
                    Reference Member ID (Optional)
                    <span className="text-gray-400 text-sm font-normal ml-2">
                      Enter if you were referred by an existing member
                    </span>
                  </label>
                  <div className="flex gap-3">
                    <div className="flex-1">
                      <div className="relative">
                        <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
                        </svg>
                        <input
                          type="text"
                          name="referenceMemberId"
                          value={formData.referenceMemberId}
                          onChange={handleInputChange}
                          onBlur={handleReferenceMemberIdBlur}
                          className={`w-full pl-10 pr-4 py-3 bg-gray-800/50 border rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent placeholder-gray-400 ${formErrors.referenceMemberId ? 'border-red-500' : 'border-gray-600'
                            }`}
                          placeholder="Enter reference member ID"
                          disabled={formData.referenceMemberVerified}
                        />
                      </div>
                      {formErrors.referenceMemberId && (
                        <p className="text-red-400 text-sm mt-1">{formErrors.referenceMemberId}</p>
                      )}
                    </div>
                    <button
                      type="button"
                      onClick={verifyReferenceMemberId}
                      disabled={verifyingReferenceMember || !formData.referenceMemberId.trim() || formData.referenceMemberVerified}
                      className="px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 disabled:from-gray-700 disabled:to-gray-800 disabled:cursor-not-allowed rounded-lg font-medium flex items-center gap-2 min-w-[120px] justify-center"
                    >
                      {verifyingReferenceMember ? (
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                      ) : (
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      )}
                      {verifyingReferenceMember ? "Verifying..." : "Verify ID"}
                    </button>
                  </div>

                  {formData.referenceMemberVerified && formData.referenceMemberDetails && (
                    <div className="mt-3 p-3 bg-gradient-to-r from-green-900/20 to-emerald-900/20 rounded-lg border border-green-700/50">
                      <div className="flex items-center gap-2 text-green-400 mb-2">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="font-bold">Reference Member Verified!</span>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-2 text-sm">
                        <div>
                          <span className="text-gray-400">Member ID:</span>
                          <span className="text-white ml-2 font-mono">{formData.referenceMemberDetails.memberId}</span>
                        </div>
                        <div>
                          <span className="text-gray-400">Name:</span>
                          <span className="text-white ml-2">{formData.referenceMemberDetails.name || "N/A"}</span>
                        </div>
                        <div>
                          <span className="text-gray-400">Email:</span>
                          <span className="text-white ml-2">{formData.referenceMemberDetails.email}</span>
                        </div>
                        <div>
                          <span className="text-gray-400">Member Type:</span>
                          <span className="text-white ml-2 capitalize">{formData.referenceMemberDetails.memberType}</span>
                        </div>
                      </div>
                    </div>
                  )}

                  <p className="text-gray-500 text-xs mt-2">
                    Leave empty if you don't have a reference member
                  </p>
                </div>

                {/* Rest of the form */}
                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-white outline-none transition-all placeholder-gray-400 ${formErrors.fullName ? 'border-red-500' : 'border-gray-600'
                      }`}
                    placeholder="Enter your full name"
                  />
                  {formErrors.fullName && (
                    <p className="text-red-400 text-sm mt-1">{formErrors.fullName}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Contact Number *
                  </label>
                  <input
                    type="tel"
                    name="contactNumber"
                    value={formData.contactNumber}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-white outline-none transition-all placeholder-gray-400 ${formErrors.contactNumber ? 'border-red-500' : 'border-gray-600'
                      }`}
                    placeholder="Enter your 10-digit phone number"
                  />
                  {formErrors.contactNumber && (
                    <p className="text-red-400 text-sm mt-1">{formErrors.contactNumber}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-white outline-none transition-all placeholder-gray-400 ${formErrors.email ? 'border-red-500' : 'border-gray-600'
                      }`}
                    placeholder="Enter your email address"
                  />
                  {formErrors.email && (
                    <p className="text-red-400 text-sm mt-1">{formErrors.email}</p>
                  )}
                </div>

                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    State *
                  </label>
                  <select
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-white outline-none transition-all ${formErrors.state ? 'border-red-500' : 'border-gray-600'
                      }`}
                  >
                    <option value="">Select State</option>

                    {/* <!-- 28 STATES --> */}
                    <option value="AP">Andhra Pradesh</option>
                    <option value="AR">Arunachal Pradesh</option>
                    <option value="AS">Assam</option>
                    <option value="BR">Bihar</option>
                    <option value="CG">Chhattisgarh</option>
                    <option value="GA">Goa</option>
                    <option value="GJ">Gujarat</option>
                    <option value="HR">Haryana</option>
                    <option value="HP">Himachal Pradesh</option>
                    <option value="JH">Jharkhand</option>
                    <option value="KA">Karnataka</option>
                    <option value="KL">Kerala</option>
                    <option value="MP">Madhya Pradesh</option>
                    <option value="MH">Maharashtra</option>
                    <option value="MN">Manipur</option>
                    <option value="ML">Meghalaya</option>
                    <option value="MZ">Mizoram</option>
                    <option value="NL">Nagaland</option>
                    <option value="OD">Odisha</option>
                    <option value="PB">Punjab</option>
                    <option value="RJ">Rajasthan</option>
                    <option value="SK">Sikkim</option>
                    <option value="TN">Tamil Nadu</option>
                    <option value="TS">Telangana</option>
                    <option value="TR">Tripura</option>
                    <option value="UP">Uttar Pradesh</option>
                    <option value="UK">Uttarakhand</option>
                    <option value="WB">West Bengal</option>

                    {/* <!-- 8 UNION TERRITORIES --> */}
                    <option value="AN">Andaman and Nicobar Islands</option>
                    <option value="CH">Chandigarh</option>
                    <option value="DN">Dadra and Nagar Haveli and Daman and Diu</option>
                    <option value="DL">Delhi (NCT of Delhi)</option>
                    <option value="JK">Jammu and Kashmir</option>
                    <option value="LA">Ladakh</option>
                    <option value="LD">Lakshadweep</option>
                    <option value="PY">Puducherry</option>

                  </select>
                  {formErrors.state && (
                    <p className="text-red-400 text-sm mt-1">{formErrors.state}</p>
                  )}
                </div>

                {/* ✅ NEW: ADDRESS FIELDS SECTION */}
                <div className="p-4 bg-gradient-to-r from-blue-900/10 to-cyan-900/10 rounded-xl border border-blue-700/20">
                  <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    Address Details
                  </h3>

                  <div className="space-y-4">
                    {/* City */}
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-2">
                        City *
                      </label>
                      <input
                        type="text"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400 ${formErrors.city ? 'border-red-500' : 'border-gray-600'
                          }`}
                        placeholder="Enter your city"
                      />
                      {formErrors.city && (
                        <p className="text-red-400 text-sm mt-1">{formErrors.city}</p>
                      )}
                    </div>

                    {/* Address */}
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-2">
                        Complete Address *
                      </label>
                      <textarea
                        name="address"
                        value={formData.address}
                        onChange={handleInputChange}
                        rows="3"
                        className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400 ${formErrors.address ? 'border-red-500' : 'border-gray-600'
                          }`}
                        placeholder="Enter your complete address (street, area, landmark)"
                      />
                      {formErrors.address && (
                        <p className="text-red-400 text-sm mt-1">{formErrors.address}</p>
                      )}
                    </div>

                    {/* PIN Code */}
                    <div>
                      <label className="block text-sm font-medium text-gray-300 mb-2">
                        PIN Code *
                      </label>
                      <input
                        type="text"
                        name="pinCode"
                        value={formData.pinCode}
                        onChange={handleInputChange}
                        maxLength="6"
                        className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400 ${formErrors.pinCode ? 'border-red-500' : 'border-gray-600'
                          }`}
                        placeholder="Enter 6-digit PIN code"
                      />
                      {formErrors.pinCode && (
                        <p className="text-red-400 text-sm mt-1">{formErrors.pinCode}</p>
                      )}
                    </div>
                  </div>
                </div>
                {/* ✅ NEW: GST Number Field */}
                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    GST Number (Optional)
                    <span className="text-gray-400 text-sm font-normal ml-2">
                      (15 characters format: 99AAAAA9999A9Z9)
                    </span>
                  </label>
                  <div className="relative">
                    <svg className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.801 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.801 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                    </svg>
                    <input
                      type="text"
                      name="gstNumber"
                      value={formData.gstNumber}
                      onChange={handleInputChange}
                      className={`w-full pl-10 pr-4 py-3 bg-gray-800/50 border rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent placeholder-gray-400 ${formErrors.gstNumber ? 'border-red-500' : 'border-gray-600'
                        }`}
                      placeholder="22AAAAA0000A1Z5"
                      maxLength="15"
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  {formErrors.gstNumber && (
                    <p className="text-red-400 text-sm mt-1">{formErrors.gstNumber}</p>
                  )}
                  <p className="text-gray-500 text-xs mt-1 flex items-center gap-1">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Leave empty if you don't have a GST number
                  </p>
                </div>

                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Member Type
                  </label>
                  <input
                    type="text"
                    name="memberType"
                    value={formData.memberType}
                    readOnly
                    className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-gray-300 cursor-not-allowed font-semibold"
                  />
                  <p className="text-gray-400 text-sm mt-1">Selected membership plan</p>
                </div>
                {/* Associate Code */}
                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Associate Code
                    <span className="text-gray-400 text-sm font-normal ml-2">
                      (Optional - Enter if you were referred by an associate)
                    </span>
                  </label>
                  <input
                    type="text"
                    name="associateCode"
                    value={formData.associateCode}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-white outline-none transition-all placeholder-gray-400 ${formErrors.associateCode ? 'border-red-500' : 'border-gray-600'
                      }`}
                    placeholder="Enter associate code (e.g., ASC001) or leave empty for none"
                    maxLength="50"
                  />
                  {formErrors.associateCode && (
                    <p className="text-red-400 text-sm mt-1">{formErrors.associateCode}</p>
                  )}
                  <div className="text-gray-500 text-xs mt-1 flex items-center gap-1">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    Leave empty or enter "-" if you don't have an associate code
                  </div>
                </div>

                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Date Joined
                  </label>
                  <input
                    type="date"
                    name="dateJoined"
                    value={formData.dateJoined}
                    readOnly
                    className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-gray-400 cursor-not-allowed"
                  />
                </div>

                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Biography *
                    <span className="text-gray-400 text-sm font-normal ml-2">
                      (Tell us about yourself, at least 2 characters)
                    </span>
                  </label>
                  <textarea
                    name="biography"
                    value={formData.biography}
                    onChange={handleInputChange}
                    rows="4"
                    className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-white outline-none transition-all placeholder-gray-400 resize-none ${formErrors.biography ? 'border-red-500' : 'border-gray-600'
                      }`}
                    placeholder="Tell us about your background, interests, and why you want to join MASA..."
                  />
                  <div className="flex justify-between text-sm mt-1">
                    <span className="text-gray-400">
                      {formData.biography.length} characters
                    </span>
                    {formErrors.biography && (
                      <span className="text-red-400">{formErrors.biography}</span>
                    )}
                  </div>
                </div>

                {/* Interests Selection (Single Selection) */}
                {/* Interests Selection (Single Selection) */}
                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Interests
                    <span className="text-gray-400 text-sm font-normal ml-2">
                      (Select your primary area of interest)
                    </span>
                  </label>

                  {loadingInterests ? (
                    <div className="text-center py-4">
                      <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 mx-auto"></div>
                      <p className="text-gray-400 text-sm mt-2">Loading interests...</p>
                    </div>
                  ) : (
                    <>
                      <div className="flex justify-between items-center mb-4">
                        <div>
                          <span className="text-sm text-gray-400">
                            {flattenedKeywords.length} interest(s) available for {selectedPlan}
                          </span>
                        </div>
                        <div>
                          {selectedInterest && (
                            <button
                              type="button"
                              onClick={handleClearInterest}
                              className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-sm rounded-lg transition-colors"
                            >
                              Clear Selection
                            </button>
                          )}
                        </div>
                      </div>

                      {flattenedKeywords.length === 0 ? (
                        <div className="text-center py-8 border-2 border-dashed border-gray-600 rounded-lg">
                          <svg className="w-12 h-12 text-gray-500 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                          </svg>
                          <p className="text-gray-400">No interests available for {selectedPlan}</p>
                          <p className="text-gray-500 text-sm mt-1">Please select a different membership plan</p>
                        </div>
                      ) : (
                        <>
                          <div className="mb-2">
                            <div className="flex items-center justify-between">
                              <span className="text-xs text-gray-400">
                                Showing {flattenedKeywords.length} interest(s)
                              </span>
                              <span className="text-xs text-blue-400">
                                Click to select one
                              </span>
                            </div>
                          </div>

                          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 max-h-60 overflow-y-auto p-2 border border-gray-600 rounded-lg">
                            {flattenedKeywords.map((keyword, index) => (
                              <div
                                key={`${index}-${keyword}`}
                                className={`p-3 rounded-lg cursor-pointer transition-all ${selectedInterest === keyword
                                  ? 'bg-blue-600 text-white border-2 border-blue-400'
                                  : 'bg-gray-800 hover:bg-gray-700 text-gray-300 border border-gray-600'
                                  }`}
                                onClick={() => handleInterestSelect(keyword)}
                              >
                                <div className="flex items-center gap-2">
                                  <div className={`w-4 h-4 rounded flex items-center justify-center ${selectedInterest === keyword
                                    ? 'bg-white'
                                    : 'bg-gray-600'
                                    }`}>
                                    {selectedInterest === keyword && (
                                      <svg className="w-3 h-3 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                      </svg>
                                    )}
                                  </div>
                                  <span className="text-sm">{keyword}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      )}

                      <p className="text-gray-400 text-sm mt-2">
                        Selected: <span className="text-white font-medium">{selectedInterest || 'None'}</span>
                      </p>


                    </>
                  )}
                </div>

                {/* Business Ethics & Compliance Section */}
                <div className="mt-8 pt-6 border-t border-gray-700">
                  <h3 className="text-xl font-semibold text-white mb-4">
                    Business Ethics & Compliance
                  </h3>
                  <p className="text-gray-400 text-sm mb-6">
                    MASA believes that real scale comes from character before capital and values before valuation.
                  </p>

                  {/* Ethics Declaration */}
                  <div className="mb-6">
                    <h4 className="text-gray-300 font-medium mb-3">
                      Ethics & Compliance Self-Declaration
                    </h4>
                    <div className="bg-gray-800/50 p-4 rounded-lg border border-gray-700 mb-3">
                      <p className="text-gray-300 text-sm mb-4">
                        <strong>Declaration of Ethical Conduct:</strong><br />
                        I hereby declare that my enterprise operates with integrity and transparency and does not knowingly engage in fraudulent practices, bribery, tax evasion, misrepresentation of products or services, or violation of applicable laws. I understand that MASA reserves the right to suspend or terminate membership if ethical misconduct is established.
                      </p>
                      <div className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          id="ethicsDeclaration"
                          name="ethicsDeclaration"
                          checked={formData.ethicsDeclaration}
                          onChange={(e) => setFormData(prev => ({
                            ...prev,
                            ethicsDeclaration: e.target.checked
                          }))}
                          className="w-5 h-5 rounded border-gray-600 bg-gray-700"
                        />
                        <label htmlFor="ethicsDeclaration" className="text-gray-300">
                          Yes, I agree
                        </label>
                      </div>
                      {formErrors.ethicsDeclaration && (
                        <p className="text-red-400 text-sm mt-2">{formErrors.ethicsDeclaration}</p>
                      )}
                    </div>
                  </div>

                  {/* Business Philosophy */}
                  <div className="mb-6">
                    <h4 className="text-gray-300 font-medium mb-3">
                      Business Philosophy (Select one)
                    </h4>
                    <p className="text-gray-400 text-sm mb-3">
                      Which statement best reflects your business philosophy?
                    </p>
                    <div className="space-y-3">
                      {[
                        'Sustainable growth with ethical practices, even if growth is slower',
                        'Fast growth is acceptable even if rules need to be bent',
                        'Still evolving my understanding of ethical business practices'
                      ].map((option, index) => (
                        <div key={index} className="flex items-center gap-3">
                          <input
                            type="radio"
                            id={`philosophy${index}`}
                            name="businessPhilosophy"
                            value={option}
                            checked={formData.businessPhilosophy === option}
                            onChange={(e) => setFormData(prev => ({
                              ...prev,
                              businessPhilosophy: e.target.value
                            }))}
                            className="w-5 h-5"
                          />
                          <label htmlFor={`philosophy${index}`} className="text-gray-300 text-sm">
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>
                    {formErrors.businessPhilosophy && (
                      <p className="text-red-400 text-sm mt-2">{formErrors.businessPhilosophy}</p>
                    )}
                  </div>

                  {/* Regulatory History */}
                  <div className="mb-6">
                    <h4 className="text-gray-300 font-medium mb-3">
                      Regulatory / Legal History
                    </h4>
                    <p className="text-gray-400 text-sm mb-3">
                      Have you or your enterprise faced any regulatory, financial, or legal action in the last 5 years?
                    </p>
                    <div className="flex gap-6 mb-4">
                      {['No', 'Yes'].map((option) => (
                        <div key={option} className="flex items-center gap-3">
                          <input
                            type="radio"
                            id={`regulatory${option}`}
                            name="regulatoryHistory"
                            value={option}
                            checked={formData.regulatoryHistory === option}
                            onChange={(e) => setFormData(prev => ({
                              ...prev,
                              regulatoryHistory: e.target.value,
                              regulatoryExplanation: e.target.value === 'No' ? '' : prev.regulatoryExplanation
                            }))}
                            className="w-5 h-5"
                          />
                          <label htmlFor={`regulatory${option}`} className="text-gray-300">
                            {option}
                          </label>
                        </div>
                      ))}
                    </div>

                    {formData.regulatoryHistory === 'Yes' && (
                      <div className="mt-4">
                        <label className="block text-gray-300 text-sm mb-2">
                          Please briefly explain
                        </label>
                        <textarea
                          name="regulatoryExplanation"
                          value={formData.regulatoryExplanation}
                          onChange={handleInputChange}
                          rows="3"
                          className={`w-full px-4 py-3 bg-gray-800/50 border rounded-lg focus:ring-2 focus:ring-blue-500 text-white outline-none ${formErrors.regulatoryExplanation ? 'border-red-500' : 'border-gray-600'}`}
                          placeholder="Provide details of the regulatory, financial, or legal actions..."
                        />
                        {formErrors.regulatoryExplanation && (
                          <p className="text-red-400 text-sm mt-1">{formErrors.regulatoryExplanation}</p>
                        )}
                      </div>
                    )}

                    {formErrors.regulatoryHistory && (
                      <p className="text-red-400 text-sm mt-2">{formErrors.regulatoryHistory}</p>
                    )}
                  </div>
                </div>



                <div>
                  <label className="block text-gray-300 font-medium mb-2">
                    Profile Photo

                  </label>

                  {formData.profilePhotoPreview ? (
                    <div className="mb-4">
                      <div className="flex items-center gap-4">
                        <img
                          src={formData.profilePhotoPreview}
                          alt="Profile preview"
                          className="w-20 h-20 object-cover rounded-lg border-2 border-gray-600"
                        />
                        <button
                          type="button"
                          onClick={removeProfilePhoto}
                          className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors"
                        >
                          Remove Photo
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="border-2 border-dashed border-gray-600 rounded-lg p-6 text-center hover:border-gray-500 transition-colors">
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="hidden"
                        id="profilePhoto"
                      />
                      <label htmlFor="profilePhoto" className="cursor-pointer">
                        <div className="flex flex-col items-center justify-center gap-2">
                          <div className="w-12 h-12 bg-gray-700 rounded-full flex items-center justify-center">
                            <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                            </svg>
                          </div>
                          <p className="text-gray-400 text-sm">
                            Click to upload profile photo
                          </p>
                          <p className="text-gray-500 text-xs">
                            PNG, JPG, JPEG up to 5MB
                          </p>
                        </div>
                      </label>
                    </div>
                  )}
                  {formErrors.profilePhoto && (
                    <p className="text-red-400 text-sm mt-1">{formErrors.profilePhoto}</p>
                  )}
                </div>
              </div>

              {/* Update this part - around line 2280-2310 */}
              <div className="flex flex-col-reverse sm:flex-row sm:justify-between items-center gap-4 mt-8 pt-6 border-t border-gray-700">
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  disabled={processingPayment}
                  className="w-full sm:flex-1 px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-medium rounded-lg transition-all hover:scale-105 disabled:opacity-50 order-2 sm:order-1"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleProceedToPayment}
                  disabled={processingPayment}
                  className="w-full sm:flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-medium rounded-lg transition-all hover:scale-105 flex items-center justify-center disabled:opacity-50 order-1 sm:order-2"
                >
                  {processingPayment ? (
                    <>
                      <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                      Processing...
                    </>
                  ) : (
                    <>
                      Proceed to Payment
                      <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Screen */}
      {paymentSuccess && <SuccessScreen />}

      <Footer />
    </div>
  );
};

export default MembershipPage;